module.exports = "/packs/media/modules/welcome/welcome/faq/assets/priceTable-c81c08e6e4a28284b4182661e6e463c5.jpg";